// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_13-1";
export var movingGradient = "_13-4";
export var movingGradientBlock = "_13-2";
export var skeleton = "_13-0";
export var skeletonText = "_13-3";